import Vue from 'vue';
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue';

Vue.use(ToastPlugin);
Vue.use(ModalPlugin);

const Toast = {
  methods: {
    Toast(title, message, type, hideDismissTime = null) {
      type = type.toLowerCase();
      let toastType = '';

      switch (type) {
        case 'error':
          type = 'danger';
          toastType = 'toast-' + type;
          break;
        case 'confirm':
          this.AlertConfirm(title, message);
          break;
      }

      this.$bvToast.toast(message, {
        title: title,
        variant: type,
        noAutoHide: !hideDismissTime ? true : false,
        toastClass: toastType,
        solid: true,
        autoHideDelay: hideDismissTime,
      });
    },
    AlertConfirm: (title, message) =>
      this.$bvModal.msgBoxConfirm(message, {
        title: title,
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Si',
        cancelTitle: 'No',
        footerClass: 'p-2',
        hideHeaderClose: true,
        centered: true,
      }),
  },
};

Vue.mixin(Toast);
